export const LoanRoleCapacity = {
  SINGLE: 'Single',
  MULTIPLE: 'Multiple',
};
